import { render, staticRenderFns } from "./BetaalMethodesHor.vue?vue&type=template&id=f98594c6&scoped=true"
import script from "./BetaalMethodesHor.vue?vue&type=script&lang=js"
export * from "./BetaalMethodesHor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98594c6",
  null
  
)

export default component.exports